import { render, staticRenderFns } from "./Responsibilities.vue?vue&type=template&id=40f89d5d&scoped=true&"
import script from "./Responsibilities.vue?vue&type=script&lang=js&"
export * from "./Responsibilities.vue?vue&type=script&lang=js&"
import style0 from "./Responsibilities.vue?vue&type=style&index=0&id=40f89d5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f89d5d",
  null
  
)

export default component.exports